/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 */
import * as React from 'react';
import BoxDefaultStyled from './styled/BoxDefaultStyled';
export var BoxDefault = function BoxDefault(props) {
  return React.createElement(BoxDefaultStyled, Object.assign({}, props));
};